module.exports = __webpack_public_path__ + "media/npc_dota_hero_obsidian_destroyer.b23be37e.webm";